/**
 * Created by DSadler on 25/04/2017.
 */
import React, {Component} from 'react';
import * as _ from "lodash";
import {GridList, GridTile, Subheader} from "material-ui";
import {DeviceWidgets} from "material-ui/svg-icons/index";

class BuildingBlocks extends Component {
  render() {
    let grids =  _.map(this.props.contentItemDefCategories, (configCategory) => {
      let gridItems = _.reject(_.filter(this.props.contentItemDefs, {configCategory}), {toolboxHide: true});
      return (
        <GridList cols={4} key={configCategory}>
          <Subheader>{configCategory}</Subheader>
          {
            gridItems.map((o) => {
              return (
                <GridTile
                  key={o.configId}
                  draggable={true}
                  title={o.configName}
                  onDragStart={(e) => {
                    this.props.handleDrag(e, o);
                  }}
                  onDragEnd={this.props.handleDragEnd}
                  >
                  <DeviceWidgets
                    style={{width: "100%", height:"100%", color:"grey"}}
                    />
                </GridTile>
              );
            })
          }
        </GridList>
      );
    });
    
    return (
      <div>
          {grids.map((o) => o)}
      </div>
    );
  }
}

export default BuildingBlocks;


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/BuildingBlocks.js